import "../styles/style.css"; // Import global styles

import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const About = () => (
  <>
    <Header />
    <div className="author-info">
      <h2 style={{ fontSize: '3em', fontWeight: 'bold', marginBottom: '0.2em' }}>About</h2>
      <div className="author-description">
        Treat life with <span style={{ color: '#6c63ff', fontWeight: 700 }}>ALACRITY</span>
      </div>
    </div>

    <main style={{ maxWidth: '95%', margin: '3em auto 2em auto', padding: '3em 3em 2.5em 3em' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '2em' }}>
        <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=300&q=80"
          alt="Daphna Keidar"
          style={{ height: '100%', maxHeight: 260, objectFit: 'cover', borderRadius: 12, boxShadow: '0 2px 12px rgba(108,99,255,0.12)', flexShrink: 0, alignSelf: 'stretch' }} />
        <section style={{ fontSize: '1.18em', color: '#333', lineHeight: 1.7 }}>
          <p style={{ marginBottom: '1.2em' }}>
            I paint in my free time, trying to put on paper some of the beautiful moments I see.
          </p>
          <p style={{ marginBottom: '1.2em' }}>
            I love colourful messes, but also precise logic.
          </p>
          <p style={{ marginBottom: '1.2em' }}>
            Both markets, with piles of merchandise and people crammed together, and silent moments in privacy.
          </p>
        </section>
      </div>
      <div style={{ textAlign: 'center', marginTop: '2em', display: 'flex', justifyContent: 'center', gap: '1.5em' }}>
        <a href="/art" className="btn" style={{ minWidth: 120 }}>Art Gallery</a>
        <a href="/research" className="btn" style={{ minWidth: 120 }}>Research</a>
      </div>
    </main>
    <Footer />
    <hr style={{ border: 'none', borderTop: '1px solid #ccc' }} />
  </>
);

export default About;
